<template>
    <div
        class="card card-custom gutter-b dm-manuscript-presentation-full"
        v-if="submission"
    >
        <div class="card-body">
            <div class="d-flex dm-submission-card-content-wrap">
                <div class="flex-shrink-0 dm-manuscript-preview-sidebar">
                    <div class="symbol symbol-50 symbol-lg-250 symbol-light-danger mb-6">
                        <ManuscriptCoverModern
                            :cover_image="submission.modern_cover"
                            class="size-1-single"
                        />
                    </div>

                    <TaxonomiesList
                        v-if="submission.taxonomies"
                        :taxonomies="submission.taxonomies"
                    />

                    <AuthorCredentials
                        v-if="submission && submission.author_credentials"
                        :submission="submission"
                    />
                </div>

                <div
                    class="flex-grow-1 font-size-lg dm-manuscript-preview-content"
                    v-if="submission.content"
                >
                    <div class="d-flex align-items-top justify-content-between flex-wrap mt-0">
                        <div class="mr-3">
                            <AuthorNamesLine :submission="submission" />

                            <h1 class="d-flex align-items-center text-dark font-weight-bolder dm-title-single-manuscript-display">
                                {{ submission.content.title }}
                            </h1>

                            <h2
                                class="d-flex align-items-center text-dark font-size-h3 font-weight-normal dm-core-message-single-manuscript-display py-2 py-lg-2 mb-4"
                                v-if="
                                    submission.steps_enabled &&
                                    submission.steps_enabled.includes(
                                        'core-message',
                                    )
                                "
                            >
                                {{ submission.content.core_message }}
                            </h2>
                        </div>
                    </div>

                    <div
                        class="dm-submission-single-content-block-black"
                        v-if="
                            submission.steps_enabled &&
                            submission.steps_enabled.includes('description')
                        "
                        v-html="submission.content.description"
                    ></div>

                    <IllustrationsList
                        v-if="
                            submission &&
                            submission.illustrations &&
                            submission.illustrations.length
                        "
                        :illustrations="submission.illustrations"
                    />

                    <div
                        class="dm-submission-single-content-block-gray"
                        v-if="submission.temp_personal_note"
                    >
                        <span class="d-flex align-items-center text-dark font-weight-bolder mb-2">{{ translate("Your personal note to the publisher") }}</span>
                        <div v-html="submission.temp_personal_note"></div>
                    </div>

                    <div
                        class="dm-submission-single-content-block-gray"
                        v-if="
                            submission.steps_enabled &&
                            submission.steps_enabled.includes(
                                'about-yourself',
                            ) &&
                            submission.content.biography
                        "
                    >
                        <span class="d-flex align-items-center text-dark font-weight-bolder mb-2">{{ translate("Author Bio") }}</span>
                        <div v-html="submission.content.biography"></div>
                    </div>


                    <div
                        class="dm-submission-single-content-block-gray"
                        v-if="
                            submission.steps_enabled &&
                            submission.steps_enabled.includes(
                                'detailed-summary',
                            ) &&
                            submission.content.detailed_summary
                        "
                    >
                        <span class="d-flex align-items-center text-dark font-weight-bolder mb-2">{{ translate("Detailed Summary") }}</span>

                        <div v-html="submission.content.detailed_summary"></div>
                    </div>

                    <div
                        class="dm-submission-single-content-block-gray"
                        v-if="
                            submission.steps_enabled &&
                            submission.steps_enabled.includes(
                                'submission-history',
                            )
                        "
                    >
                        <SubmissionHistoryWidget
                            v-if="submission.submission_history"
                            :submission_history="submission.submission_history"
                        />
                    </div>

                    <div
                        class="dm-submission-single-content-block-gray"
                        v-if="
                            submission.steps_enabled &&
                            submission.steps_enabled.includes('why-us')
                        "
                    >
                        <p v-if="submission.heard_from">
                            {{ translate("Heard about us") }}:
                            {{ submission.heard_from }}
                        </p>

                        <p>
                            {{ translate("Subscribe to news") }}:
                            <BooleanString :is_true="submission.subscribe_news" />
                        </p>
                    </div>

                    <div class="dm-sample-full-wrapper">
                        <span class="d-flex align-items-center text-dark font-weight-bolder mb-2">{{ translate("Manuscript submitted") }}</span>
                        <div class="dm-sample-full-and-pdf-block mb-4">
                            <StatCard
                                icon="document"
                                :label="translate('Full')"
                                :link="submission.full_url"
                            />

                            <StatCard
                                icon="document"
                                :label="translate('Sample')"
                                :link="submission.sample_url"
                            />

                            <PersonalNoteButton
                                v-if="submission.personal_note"
                                :personal_note="submission.personal_note"
                            />

                            <div class="mb-0">
                                <PresentationAsPdfButton :submission_id="submission.id" />
                            </div>
                        </div>
                    </div>

                    <slot name="cta-slot"></slot>
                </div>
            </div>

            <div class="separator separator-solid my-5"></div>

            <slot name="tabs-slot"><!-- IMPORTANT: The SubmissionTabs component is added here from EditorSubmissionSingle and PreviewManuscript. There we specify whether to include Notes or not --></slot>
        </div>
    </div>
</template>

<script>
import PersonalNoteButton from "@/components/author/manuscripts/index/partials/manuscript-card/PersonalNoteButton.vue";
import IllustrationsList from "@/components/editor/submissions/shared/IllustrationsList.vue";
import SubmissionHistoryWidget from "@/components/editor/submissions/single/partials/SubmissionHistoryWidget.vue";
import StatCard from "@/components/shared/manuscript-card/StatCard.vue";
import PresentationAsPdfButton from "@/components/shared/manuscript/PresentationAsPdfButton.vue";
import ManuscriptCoverModern from "@shared/manuscript-cover/ManuscriptCoverModern.vue";
import AuthorCredentials from "@shared/submission/author-credentials/AuthorCredentials.vue";
import TaxonomiesList from "@shared/submission/TaxonomiesList.vue";
import AuthorNamesLine from "@shared/submission/author-names-line/AuthorNamesLine.vue";

export default {
    components: {
        ManuscriptCoverModern,
        PersonalNoteButton,
        StatCard,
        PresentationAsPdfButton,
        SubmissionHistoryWidget,
        IllustrationsList,
        AuthorCredentials,
        TaxonomiesList,
        AuthorNamesLine,
    },

    props: ["submission"]
};
</script>
